export function Spinner({ size = 18 }: { size?: number }) {
  return <span className="spinner" role="status" aria-label="Loading" style={{ width: size, height: size }} />;
}
